import { Matrix4, Vector3 } from "three";


/**
 * A little baby Matrix4 transformation class to support the SweptMesh.
 */
export class Transform {
    sm: Matrix4; // scratch matrix
    sv: Vector3; // scratch vector;
    m: Matrix4; // the internal state of the transform

    constructor() {
        this.sm = new Matrix4();
        this.sv = new Vector3();
        this.m = new Matrix4();
    }

    copy(t: Transform) {
        this.m.copy(t.m);
    }

    apply(v: Vector3) {
        v.applyMatrix4(this.m);
    }

    translate(x: number, y: number, z: number) {
        this.sm.makeTranslation(x, y, z);
        this.m.premultiply(this.sm);
    }

    rotateX(theta: number) {
        this.sm.makeRotationX(theta);
        this.m.premultiply(this.sm);
    }

    rotateY(theta: number) {
        this.sm.makeRotationY(theta);
        this.m.premultiply(this.sm);
    }

    rotateZ(theta: number) {
        this.sm.makeRotationZ(theta);
        this.m.premultiply(this.sm);
    }

    shearXZ(theta: number) {
        const slope = Math.tan(theta);
        this.sm.makeShear(0, slope, 0, 0, 0, 0);
        this.m.premultiply(this.sm);
    }

    reset() {
        this.m.identity();
    }
}
